var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-wrap"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,class:{'active': _vm.activeIndex == index},on:{"click":function($event){return _vm.changeTab(index)}}},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }